export default __webpack_public_path__ + "static/voice_solution-cb1aee457ac677af41582fee266bae3a.webp";